import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  padding: 12px 16px;
  align-items: center;
  gap: 12px;
  border-radius: 16px;
  background: ${({ theme }) => theme.colors.purple1};
`;

export const GapWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;
